import React, { useContext, useEffect, useLayoutEffect, useMemo, useReducer, useState } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { RootContext } from '../../../Context/RootContext';
import Alert, { AlertType } from '../../../Shared/components/Alert';
import ComplexDetail from '../Complex/Detail/Detail';
import Listings from './Listings/Listings';
import UnitReducer from '../../hooks/UnitReducer';
import { UnitContext } from '../../context/UnitContext';
import ViewService from '../../services/ViewService';
import Detail from './Detail/Detail';
const getViewport = () => {
    return window.innerWidth < 840 ? 'mobile' : 'desktop';
};
const Units = () => {
    const rootContext = useContext(RootContext);
    const [hash, searchParams] = window.location.hash.split('?');
    const [state, dispatch] = useReducer(UnitReducer.reducer, UnitReducer.initialState(rootContext.pluginContext, new URLSearchParams(searchParams)));
    const [viewport, setViewport] = useState(getViewport());
    const unitContext = useMemo(() => ({ state, dispatch, viewport }), [state, dispatch, viewport]);
    const applyViewOnDOM = (view) => {
        view === 'map' ? ViewService.setFullWidth() : ViewService.setRegularWidth();
    };
    useLayoutEffect(() => {
        // Check if root (so list view) or a detail view.
        const path = hash.split('/').splice(1).filter(Boolean);
        if (path && path.length > 0) {
            applyViewOnDOM('detail');
        }
    });
    useEffect(() => {
        function handleResize() {
            const newViewport = getViewport();
            if (viewport !== newViewport) {
                setViewport(newViewport);
            }
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [viewport]);
    if (rootContext.pluginContext.filters.length === 0) {
        return (React.createElement(Alert, { message: "t(tx_zigrealestate.error.notConfigured.message)", title: "t(tx_zigrealestate.error.notConfigured.title)", type: AlertType.error }));
    }
    return (React.createElement(UnitContext.Provider, { value: unitContext },
        React.createElement(HashRouter, { basename: "/" },
            React.createElement(QueryParamProvider, { ReactRouterRoute: Route },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: '/:id+' }, state.currentFilterGroup === 'complex' ? React.createElement(ComplexDetail, null) : React.createElement(Detail, null)),
                    React.createElement(Route, { component: Listings }))))));
};
export default Units;
